import { render } from "./ShoppingRoomDesign.vue?vue&type=template&id=668d1194&scoped=true"
import script from "./ShoppingRoomDesign.vue?vue&type=script&lang=js"
export * from "./ShoppingRoomDesign.vue?vue&type=script&lang=js"

import "./ShoppingRoomDesign.vue?vue&type=style&index=0&id=668d1194&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668d1194"]])

export default __exports__